import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'; // 配置请求头
if (process.env.NODE_ENV == "production") {
    //axios.defaults.baseURL = "http://47.97.207.237:8085"//生产环境地址
    axios.defaults.baseURL = "https://services.space.aigyzn.com"//生产环境地址
} else if (process.env.NODE_ENV == "development") {
    axios.defaults.baseURL = "https://services.space.aigyzn.com"//开发环境
} else {
    axios.defaults.baseURL = "https://services.space.aigyzn.com"//测试环境地址
    // axios.defaults.baseURL = "http://h5.clouddisk.aigyzn.com"//开发环境地址
    // axios.defaults.baseURL = "http://192.168.0.2:8080"//开发环境地址
}
// 使用自定义配置新建一个 axios 实例
const service = axios.create({

    // baseURL: "http://47.97.207.237:8085",
    timeout: 30000,
    transformRequest: [(data) => {
        data = JSON.stringify(data)
        return data
    }],
    validateStatus () {
        // 使用async-await，处理reject情况较为繁琐，所以全部返回resolve，在业务代码中处理异常
        return true
    },
    transformResponse: [(data) => {
        if (typeof data === 'string' && data.startsWith('{')) {
            data = JSON.parse(data)
        }
        return data
    }]
});


// 请求拦截器，例如请求的时候在头部加上请求的token
service.interceptors.request.use(config => {
    // let token = "5e1219bb-43aa-4ed8-bd65-072c358e8272"
    // config.headers.token = token

    return config;  //  有且必须有一个config对象被返回

}, error => {
    //   对请求错误做些什么
    return Promise.reject();
});


// 响应拦截器,例如判断服务器返回的状态，400，500啥的，其实超时可以写到这里面来，我分开写了一个比较直观
service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况,这些自定义（需要与后台商量返回）
    error => {
        if (
            400 <= error.response.status < 500
        ) {
            alert("用户信息过期，请重新登陆");
            // 清除token
            // localStorage.removeItem("token");
            // 跳转登录
            setTimeout(() => {
                //   window.location.href = "/login";
            }, 1000);
        } else {
            if (error.response.status >= 500) {
                alert("服务器开小差了，请稍后再试！");
            } else {
                alert("服务器开小差了，请稍后再试！");
                return Promise.reject(error)
            }
        }
    }
);

export default service;


// WEBPACK FOOTER //
// ./src/request/index.js